import { COLOR } from '@george-labs.com/design-system';

export const creditCardContentBox = {
    showLockAndUnlockNavigation: true,
    showDisplayPinNavigation: true,
    showBalanceIncreaseNavigation: true,
    cardMeter: {
        addAuthorizedAmountToValue: true,
        limitReachedColor: COLOR.UI_RED,
    },
    cardLegend: {
        invertAuthorizedAmount: true,
        showBalanceAsOutstandingAmount: true,
    },
};
